import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import ImageUpload from "./ImageUpload";

const Block1 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
  selectedSize,
}) => {
  const [selectedImages, setSelectedImages] = useState("");
  const [BlobImage, setBlobImage] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false);
  const [EnableCroping, setEnableCroping] = useState(false);
  const [ResetZoom, setResetZoom] = useState(false);

  useEffect(() => {
    if (addToCartTriggered) {
      capture();
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    console.log(selectedImages);
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview) => {
    console.log(imagePreview);
    setSelectedImages([imagePreview]);
    setShowCropIcon(true);
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
    });
  };
  console.log(selectedSize);

  const [TopImagetrigger, setTopImagetrigger] = useState(false);

  return (
    <>
      {(selectedSize?.type === "art_tray" ||
        selectedSize?.type === "wood_print") && (
        <div className="large-bg collage-40 images-12-12">
          <div className="row">
            <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4 align-items-center">
              <div
                className={`number-line ${
                  selectedSize?.type
                } ${selectedSize?.size
                  .replace(/["']/g, "")
                  .replace(/\s/g, "_")
                  .replace(/^(\d+)/, "s$1")}`}
              >
                {/* <span>
                  {selectedSize?.type === "art_tray" &&
                  selectedSize?.size === '12" x 20"'
                    ? '12"'
                    : selectedSize?.type === "wood_print" &&
                      selectedSize?.size === '12" x 15"'
                    ? '15"'
                    : ""}
                </span> */}
              </div>
              <div
                className="d-flex art-tray-add"
                id="captureArea"
                style={{ position: "relative" }}
              >
                {selectedSize?.type === "art_tray" && (
                  <>
                    <div className="image-box">
                      <img
                        src="assets/img/breadcrumb/bord_art_frame.png"
                        alt=""
                        className="art_tray-12-20_border"
                      />
                    </div>
                    <div
                      className=""
                      style={{
                        position: "absolute",
                        top: "36px",
                        right: "50px",
                      }}
                    >
                      <ImageUpload
                        defaultImage={
                          selectedSize?.type === "art_tray" &&
                          selectedSize?.size === '12" x 20"'
                            ? "assets/img/breadcrumb/inn_art_frame1.svg"
                            : "assets/img/blog/thumb.png"
                        }
                        onChange={(e) => {
                          handleImageChange(e);
                        }}
                        className={
                          selectedSize?.type === "art_tray" &&
                          selectedSize?.size === '12" x 20"'
                            ? "art_tray-12-20"
                            : "art_tray-12-20"
                        }
                        CropEnable={EnableCroping}
                        resetzoom={ResetZoom}
                      />
                    </div>
                  </>
                )}

                {selectedSize?.type === "wood_print" && (
                  <>
                    <div className="image-box">
                      <img
                        src="assets/img/breadcrumb/out_wood_print.png"
                        alt=""
                        className="wood_print_border"
                        onClick={() => setTopImagetrigger(!TopImagetrigger)}
                      />
                    </div>
                    <div
                      className=""
                      style={{
                        position: "absolute",
                        top: "12px",
                        right: "8px",
                      }}
                    >
                      <ImageUpload
                        //   defaultImage={"assets/img/breadcrumb/out_wood_print.png"}
                        onChange={(e) => {
                          handleImageChange(e);
                        }}
                        PlexiImageTrigger={TopImagetrigger}
                        DataFrom="Plexi"
                        className={"wood_print_innerImg opacity-50"}
                        CropEnable={EnableCroping}
                        resetzoom={ResetZoom}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              className={`number-line-2 ${
                selectedSize?.type
              }  ${selectedSize?.size
                .replace(/["']/g, "")
                .replace(/\s/g, "_")
                .replace(/^(\d+)/, "s$1")}`}
            >
              {/* <span>
                {selectedSize?.type === "art_tray" &&
                selectedSize?.size === '12" x 20"'
                  ? '20"'
                  : selectedSize?.type === "wood_print" &&
                    selectedSize?.size === '12" x 15"'
                  ? '12"'
                  : ""}
              </span> */}

              {ShowCropIcon && !EnableCroping && (
                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="mx-5 btn btn-sm btn-secondary"
                    onClick={() => {
                      setEnableCroping(true);
                      setResetZoom(false);
                    }}
                  >
                    Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan{" "}
                    <i class="fa fa-crop pointer" aria-hidden="true"></i>
                  </button>
                  {/* <label className="mx-5 pointer">Reset</label> */}
                </div>
              )}
              {EnableCroping && (
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <label className="mx-5 fw-bold align-items-baseline d-flex">
                      {" "}
                      Crop{" "}
                      <h6 className="fw-normal text-muted ms-4">
                        Scroll to zomm and Drag to pan
                      </h6>
                    </label>
                  </div>
                  <div className="mx-5">
                    <button
                      className="me-3 btn-sm btn btn-outline-dark"
                      onClick={() => {
                        setEnableCroping(false);
                        setResetZoom(true);
                      }}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setEnableCroping(false)}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {selectedSize?.type === "plexi_print" && (
        <div className="large-bg collage-40 images-12-12">
          <div className="row">
            <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
              <div className={`number-line plexi_print`}>
                {/* <span>{selectedSize?.type === "plexi_print" ? '16"' : ""}</span> */}
              </div>
              <div className="d-flex" id="captureArea">
                <>
                  <div
                    className="image-box"
                    style={{
                      position: "relative",
                      zIndex: EnableCroping ? "0" : "9",
                      padding: "8px",
                    }}
                  >
                    <img
                      // src="assets/img/breadcrumb/top-glass-shade.png"
                      alt=""
                      className="plexiprint_top_shade pointer"
                      onClick={() => setTopImagetrigger(!TopImagetrigger)}
                    />
                  </div>
                  <div className="position-absolute">
                    <ImageUpload
                      defaultImage={"assets/img/breadcrumb/w-shade-plexi.svg"}
                      onChange={(e) => {
                        handleImageChange(e);
                      }}
                      className={"plexiprintDefault"}
                      style={{
                        // borderRadius: "10px",
                        boxShadow: "5px 5px 15px grey",
                      }}
                      PlexiImageTrigger={TopImagetrigger}
                      DataFrom="Plexi"
                      CropEnable={EnableCroping}
                      resetzoom={ResetZoom}
                    />
                  </div>
                </>
              </div>
            </div>
            <div className={`number-line-2 plexi_print`}>
              {/* <span>{selectedSize?.type === "plexi_print" ? '24"' : ""}</span> */}

              {ShowCropIcon && !EnableCroping && (
                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="mx-5 btn btn-sm btn-secondary"
                    onClick={() => {
                      setEnableCroping(true);
                      setResetZoom(false);
                    }}
                  >
                    Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan{" "}
                    <i class="fa fa-crop pointer" aria-hidden="true"></i>
                  </button>
                  {/* <label className="mx-5 pointer">Reset</label> */}
                </div>
              )}
              {EnableCroping && (
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <label className="mx-5 fw-bold align-items-baseline d-flex">
                      {" "}
                      Crop{" "}
                      <h6 className="fw-normal text-muted ms-4">
                        Scroll to zomm and Drag to pan
                      </h6>
                    </label>
                  </div>
                  <div className="mx-5">
                    <button
                      className="me-3 btn-sm btn btn-outline-dark"
                      onClick={() => {
                        setEnableCroping(false);
                        setResetZoom(true);
                      }}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setEnableCroping(false)}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {selectedSize?.type === "diamond_dust" && (
        <div className="large-bg collage-40 images-12-12">
          <div className="row">
            <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
              <div className={`number-line ${selectedSize?.type} `}>
                {/* <span>{'38"'}</span> */}
              </div>
              <div className="d-flex" id="captureArea">
                <div>
                  <ImageUpload
                    defaultImage={"assets/img/breadcrumb/new single img1.svg"}
                    onChange={(e) => {
                      handleImageChange(e);
                    }}
                    className={"diamond_dust-38x28"}
                    CropEnable={EnableCroping}
                    resetzoom={ResetZoom}
                  />
                </div>
              </div>
            </div>
            <div className={`number-line-2 ${selectedSize?.type}`}>
              {/* <span>{'28"'}</span> */}

              {ShowCropIcon && !EnableCroping && (
                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="mx-5 btn btn-sm btn-secondary"
                    onClick={() => {
                      setEnableCroping(true);
                      setResetZoom(false);
                    }}
                  >
                    Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan{" "}
                    <i class="fa fa-crop pointer" aria-hidden="true"></i>
                  </button>
                  {/* <label className="mx-5 pointer">Reset</label> */}
                </div>
              )}
              {EnableCroping && (
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <label className="mx-5 fw-bold align-items-baseline d-flex">
                      {" "}
                      Crop{" "}
                      <h6 className="fw-normal text-muted ms-4">
                        Scroll to zomm and Drag to pan
                      </h6>
                    </label>
                  </div>
                  <div className="mx-5">
                    <button
                      className="me-3 btn-sm btn btn-outline-dark"
                      onClick={() => {
                        setEnableCroping(false);
                        setResetZoom(true);
                      }}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setEnableCroping(false)}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Default = () => {
  return (
    <div className="frame-container">
      <img
        src="assets/img/blog/thumb.png"
        alt=""
        style={{ objectFit: "contain", maxWidth: "100%" }}
      />
    </div>
  );
};

export default function CustomBlocksArtTray({
  selectedSize,
  addToCartTriggered,
  sendAllSelectedImages,
  sendblobImage,
}) {
  const updateAllSelectedImages = (images) => {
    console.log(images);
    sendAllSelectedImages(images);
  };

  const SendBlobImage = (images) => {
    console.log(images);
    sendblobImage(images);
  };

  return (
    <>
      {selectedSize?.id ? (
        <Block1
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
          selectedSize={selectedSize}
        />
      ) : (
        <Default />
      )}
    </>
  );
}
